const LIGHT_TEXT = "#F8FAFC";
const DARK_TEXT = "#050A12";

function parseHexColor(color: string): [number, number, number] | null {
  const match = /^#([\da-f]{6})$/i.exec(color);
  if (!match?.[1]) return null;
  const value = Number.parseInt(match[1], 16);
  return [(value >> 16) & 255, (value >> 8) & 255, value & 255];
}

function toHexColor([red, green, blue]: [number, number, number]): string {
  return `#${[red, green, blue].map((value) => value.toString(16).padStart(2, "0")).join("")}`;
}

function luminance(color: [number, number, number]): number {
  const channels = color.map((channel) => {
    const normalized = channel / 255;
    return normalized <= 0.04045 ? normalized / 12.92 : ((normalized + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * (channels[0] ?? 0) + 0.7152 * (channels[1] ?? 0) + 0.0722 * (channels[2] ?? 0);
}

export function getContrastTextColor(backgroundColor: string): string {
  const color = parseHexColor(backgroundColor);
  if (!color) return LIGHT_TEXT;
  const backgroundLuminance = luminance(color);
  const darkLuminance = luminance(parseHexColor(DARK_TEXT) ?? [5, 10, 18]);
  const lightLuminance = luminance(parseHexColor(LIGHT_TEXT) ?? [248, 250, 252]);
  const contrastRatio = (foregroundLuminance: number): number =>
    (Math.max(backgroundLuminance, foregroundLuminance) + 0.05) /
    (Math.min(backgroundLuminance, foregroundLuminance) + 0.05);
  return contrastRatio(darkLuminance) >= contrastRatio(lightLuminance) ? DARK_TEXT : LIGHT_TEXT;
}

export function getEndingDialogueSurface(backgroundColor: string): string {
  const color = parseHexColor(backgroundColor);
  if (!color) return "#334155";
  const tint: [number, number, number] = [248, 250, 252];
  return toHexColor(color.map((channel, index) => Math.round(channel * 0.82 + (tint[index] ?? 248) * 0.18)) as [number, number, number]);
}
